import { createAction } from '@reduxjs/toolkit';
import { ActionNames, Errors } from '_constants'
import { helpCenterService } from '_services';
import { alertActions } from './alert.actions';

export const helpCenterActions = {
    categoryChange: createAction(ActionNames.HELP_CENTER_CATEGORY_CHANGE),

    getLocations: (urno) => dispatch => {
        dispatch(helpCenterActions.locationRequest({ urno }));

        helpCenterService.getLocationsForUser(urno)
            .then(
                locations => {
                    dispatch(helpCenterActions.locationSuccess({ locations }));
                },
                error => {
                    dispatch(helpCenterActions.locationFailure({ error: error }));
                    dispatch(alertActions.error(Errors.LOCATION_LOADING_FAILURE));
                }
            );
    },
    locationRequest: createAction(ActionNames.LOCATION_REQUEST),
    locationSuccess: createAction(ActionNames.LOCATION_SUCCESS),
    locationFailure: createAction(ActionNames.LOCATION_FAILURE),

}
